import React, { useRef } from 'react';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { Controller } from "react-hook-form";

interface IProps {
  name: string
  error?: any
  label?: string
  control: any
  isRequired?: boolean
  disabled?: boolean
  type?: string
  isClearable?: boolean
  options: any[]
}

const StaticSelectField = React.forwardRef<HTMLInputElement, IProps>((props: IProps, ref) => {
  const {
    name,
    error,
    label,
    control,
    isClearable,
    isRequired = false,
    options,
    disabled = false,
  } = props;

  const inputRef = useRef<HTMLInputElement>();

  if (!options || !options.length) {
    return <></>
  }

  return (
    <FormControl fullWidth>
      <Controller
        render={({ field }) => (
          <Autocomplete
            ref={ref}
            value={field.value || null}
            disableClearable={!isClearable}
            getOptionLabel={(option) => option.label}
            options={options}
            disabled={disabled}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => <TextField
              error={!!error}
              helperText={error ? error.message : null}
              required={isRequired}
              label={label}
              inputRef={inputRef}
              {...params}
              inputProps={{
                ...params.inputProps, ...{
                  'data-testid': field.name
                }
              }}
            />}
            onChange={(_event, value) => {
              field.onChange(value);
            }}
          />
        )}
        name={name}
        control={control}
      />
    </FormControl>
  );
})

StaticSelectField.defaultProps = {
  isRequired: false,
  disabled: false,
};

export { StaticSelectField };